const initialState = {
    loading: false,
    claimBonus: [],
    BonusClaimActivitiesByEvent: [],
  };
  
  const claimReducer = (state = initialState, actions) => {
    switch (actions.type) {
      case "SET_BONOUS_CLAIMS": {
        return { ...state ,...actions.payload };
      }

      case "REQUEST_BONUS_INITIALIZATION": {
        return {
          ...state,
          ...actions.payload,
          loading:true
        };
      }
  
      case "REQUEST_BONUS_TERMINATE": {
        return { ...state, ...actions.payload, loading:false };
      }
      
      default:
        return state;
    }
  };
  export default claimReducer;
  